import React, { useEffect, useState } from 'react';
import Modal from '@mui/base/Modal';
import clsx from 'clsx';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  styled,
  TextField,
  Theme,
} from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import './ModalComponent.scss';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { executors } from './executors';

type ModalComponentProps = {
  isOpenModalSend: boolean;
  handleCloseModalSend: () => void;
  handleResend: (email: string) => void;
};

type FormState = {
  email: string;
};

const ModalComponent = ({
  isOpenModalSend,
  handleCloseModalSend,
  handleResend,
}: ModalComponentProps) => {
  const [selectValue, setSelectValue] = useState('');


  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    clearErrors,
    formState: { errors, isValid, isSubmitSuccessful },
  } = useForm<FormState>({ mode: 'onSubmit', reValidateMode: 'onChange' });

  const onSubmitForm: SubmitHandler<FormState> = async (data) => {
    await handleResend(data.email);
  };
  const handleChangeSelect = (event: SelectChangeEvent) => {
    setSelectValue(event.target.value as string);
    setValue('email', event.target.value as string);
    clearErrors();
  };

  useEffect(() => {
    if (isOpenModalSend) {
      reset();
      setSelectValue('');
    };
  }, [isOpenModalSend, reset]);

  useEffect(() => {
    return () => {
      handleCloseModalSend();
      setSelectValue('');
    };
  }, [isSubmitSuccessful]);


  return (
    <StyledModal
      open={isOpenModalSend}
      onClose={handleCloseModalSend}
      slots={{ backdrop: StyledBackdrop }}
    >
      <Box sx={style}>
        <h2>Переслать на почту</h2>
        <Box component="form" onSubmit={handleSubmit(onSubmitForm)} className="resend-form">
          <Controller
            control={control}
            name="email"
            render={({ field }) => (
              <TextField
                fullWidth
                variant="standard"
                type="email"
                required
                placeholder="Введите email"
                size="small"
                error={!!errors?.email}
                helperText={errors?.email?.message || ''}
                {...register('email', {
                  required: 'Это обязательное поле',
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                    message: 'Некорректный email',
                  },
                })}
                onChange={(e) => {
                  field.onChange(e);
                  setSelectValue('');
                }}
              />
            )}
          />
          <FormControl fullWidth variant="standard">
            <InputLabel id="selectResend">Выбрать из списка</InputLabel>
            <Select
              labelId="selectResend"
              id="selectResend"
              value={selectValue || ''}
              label="Выбрать из списка"
              onChange={handleChangeSelect}
            >
              {executors.map((el, index) => (
                <MenuItem value={el.email} key={index}>
                  {el.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button variant="outlined" type="submit">
            Переслать
          </Button>
        </Box>
      </Box>
    </StyledModal>
  );
};

export default ModalComponent;

const Backdrop = React.forwardRef<HTMLDivElement, { open?: boolean; className: string }>(
  (props, ref) => {
    const { open, className, ...other } = props;
    return <div className={clsx({ 'MuiBackdrop-open': open }, className)} ref={ref} {...other} />;
  }
);

const StyledModal = styled(Modal)`
  position: fixed;
  z-index: 1300;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledBackdrop = styled(Backdrop)`
  z-index: -1;
  position: fixed;
  inset: 0;
  background-color: rgb(0 0 0 / 0.5);
  -webkit-tap-highlight-color: transparent;
`;
const style = (theme: Theme) => ({
  width: 400,
  borderRadius: '12px',
  padding: '16px 32px 24px 32px',
  backgroundColor: theme.palette.mode === 'dark' ? '#0A1929' : 'white',
  boxShadow: `0px 2px 24px ${theme.palette.mode === 'dark' ? '#000' : '#383838'}`,
});
